export default "__VITE_ASSET__1b32642f__"